import { NO_LIMIT_TEMPLATES } from './templates/noLimit';
import { FREE_LIMIT_TEMPLATES } from './templates/freeLimit';
import { STARTER_LIMIT_TEMPLATES } from './templates/starterLimit';

export const ALL_TEMPLATES = [
  ...NO_LIMIT_TEMPLATES,
  ...FREE_LIMIT_TEMPLATES,
  ...STARTER_LIMIT_TEMPLATES,
];
